export const FETCH_ACCOUNT = "FETCH_ACCOUNT";
export const FETCH_ACCOUNT_SUCCESS = "FETCH_ACCOUNT_SUCCESS";
export const FETCH_ACCOUNT_FAILURE = "FETCH_ACCOUNT_FAILURE";

export const FETCH_ACCOUNTS = "FETCH_ACCOUNTS";
export const FETCH_ACCOUNTS_SUCCESS = "FETCH_ACCOUNTS_SUCCESS";
export const FETCH_ACCOUNTS_FAILURE = "FETCH_ACCOUNTS_FAILURE";

export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_FAILURE = "CREATE_ACCOUNT_FAILURE";

export const POST_ACCOUNT = "POST_ACCOUNT";
export const POST_ACCOUNT_SUCCESS = "POST_ACCOUNT_SUCCESS";
export const POST_ACCOUNT_FAILURE = "POST_ACCOUNT_FAILURE";

export const PUT_ACCOUNT = "PUT_ACCOUNT";
export const PUT_ACCOUNT_SUCCESS = "PUT_ACCOUNT_SUCCESS";
export const PUT_ACCOUNT_FAILURE = "PUT_ACCOUNT_FAILURE";

export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_FAILURE = "DELETE_ACCOUNT_FAILURE";

// Delete accounts
export const DELETE_ACCOUNTS = "DELETE_ACCOUNTS";
export const DELETE_ACCOUNTS_SUCCESS = "DELETE_ACCOUNTS_SUCCESS";
export const DELETE_ACCOUNTS_FAILURE = "DELETE_ACCOUNTS_FAILURE";
export const DELETE_ACCOUNTS_RESET = "DELETE_ACCOUNTS_RESET";

export const FETCH_ACCOUNTS_FIELDS =
  "setSelectedSectionACCOUNTSFETCH_ACCOUNTS_FIELDS";
export const FETCH_ACCOUNTS_FIELDS_SUCCESS = "FETCH_ACCOUNTS_FIELDS_SUCCESS";
export const FETCH_ACCOUNTS_FIELDS_FAILURE = "FETCH_ACCOUNTS_FIELDS_FAILURE";

export const ACCOUNT_RESET_META_DATA = "ACCOUNT_RESET_META_DATA";

export const FETCH_ACCOUNT_DATA = "FETCH_ACCOUNT_DATA";
export const FETCH_ACCOUNT_DATA_SUCCESS = "FETCH_ACCOUNT_DATA_SUCCESS";
export const FETCH_ACCOUNT_DATA_FAILURE = "FETCH_ACCOUNT_DATA_FAILURE";

export const FETCH_ACCOUNTS_FIELDS_ALL = "FETCH_ACCOUNTS_FIELDS_ALL";
export const FETCH_ACCOUNTS_FIELDS_ALL_SUCCESS =
  "FETCH_ACCOUNTS_FIELDS_ALL_SUCCESS";
export const FETCH_ACCOUNTS_FIELDS_ALL_FAILURE =
  "FETCH_ACCOUNTS_FIELDS_ALL_FAILURE";

export const CREATE_ACCOUNT_CUSTOM_VIEW = "CREATE_ACCOUNT_CUSTOM_VIEW";
export const CREATE_ACCOUNT_CUSTOM_VIEW_SUCCESS =
  "CREATE_ACCOUNT_CUSTOM_VIEW_SUCCESS";
export const CREATE_ACCOUNT_CUSTOM_VIEW_FAILURE =
  "CREATE_ACCOUNT_CUSTOM_VIEW_FAILURE";

export const FETCH_ACCOUNT_CUSTOM_VIEW = "FETCH_ACCOUNT_CUSTOM_VIEW";
export const FETCH_ACCOUNT_CUSTOM_VIEW_SUCCESS =
  "FETCH_ACCOUNT_CUSTOM_VIEW_SUCCESS";
export const FETCH_ACCOUNT_CUSTOM_VIEW_FAILURE =
  "FETCH_ACCOUNT_CUSTOM_VIEW_FAILURE";
export const RESET_ACCOUNT_CUSTOM_VIEW = "RESET_ACCOUNT_CUSTOM_VIEW";

export const SELECT_ACCOUNT_CUSTOM_VIEW = "SELECT_ACCOUNT_CUSTOM_VIEW";
export const SELECT_ACCOUNT_CUSTOM_VIEW_SUCCESS =
  "SELECT_ACCOUNT_CUSTOM_VIEW_SUCCESS";
export const SELECT_ACCOUNT_CUSTOM_VIEW_FAILURE =
  "SELECT_ACCOUNT_CUSTOM_VIEW_FAILURE";

export const DELETE_ACCOUNT_CUSTOM_VIEW = "DELETE_ACCOUNT_CUSTOM_VIEW";
export const DELETE_ACCOUNT_CUSTOM_VIEW_SUCCESS =
  "DELETE_ACCOUNT_CUSTOM_VIEW_SUCCESS";
export const DELETE_ACCOUNT_CUSTOM_VIEW_FAILURE =
  "DELETE_ACCOUNT_CUSTOM_VIEW_FAILURE";

export const FETCH_ACCOUNT_CUSTOM_VIEW_BY_ID = "FETCH_ACCOUNT_CUSTOM_VIEW_BY_ID";
export const FETCH_ACCOUNT_CUSTOM_VIEW_BY_ID_SUCCESS = "FETCH_ACCOUNT_CUSTOM_VIEW_BY_ID_SUCCESS";
export const FETCH_ACCOUNT_CUSTOM_VIEW_BY_ID_FAILURE = "FETCH_ACCOUNT_CUSTOM_VIEW_BY_ID_FAILURE";

export const EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID = "EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID";
export const EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID_SUCCESS = "EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID_SUCCESS";
export const EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID_FAILURE = "EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID_FAILURE";

export const RESET_ACCOUNTS = "RESET_ACCOUNTS";

export const UNSELECT_ACCOUNT_CUSTOM_VIEW = "UNSELECT_ACCOUNT_CUSTOM_VIEW";
export const UNSELECT_ACCOUNT_CUSTOM_VIEW_SUCCESS = "UNSELECT_ACCOUNT_CUSTOM_VIEW_SUCCESS";
export const UNSELECT_ACCOUNT_CUSTOM_VIEW_FAILURE = "UNSELECT_ACCOUNT_CUSTOM_VIEW_FAILURE";

// Account Default Custom View
export const SET_ACCOUNT_DEFAULT_CUSTOM_VIEW = "SET_ACCOUNT_DEFAULT_CUSTOM_VIEW";
export const DELETE_ACCOUNT_DEFAULT_CUSTOM_VIEW = "DELETE_ACCOUNT_DEFAULT_CUSTOM_VIEW";

// Fetch all account owners
export const FETCH_ACCOUNT_OWNERS = "FETCH_ACCOUNT_OWNERS";
export const FETCH_ACCOUNT_OWNERS_SUCCESS = "FETCH_ACCOUNT_OWNERS_SUCCESS";
export const FETCH_ACCOUNT_OWNERS_FAILURE = "FETCH_ACCOUNT_OWNERS_FAILURE";